import React, {useCallback, useEffect, useState} from "react";
import PropTypes from "prop-types";
import {Button, FormControlLabel, Grid, makeStyles, Radio, RadioGroup, Typography} from "@material-ui/core";
import GenericDialog from "components/ui/dialogs/generic-dialog/GenericDialog";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ButtonIconLeft from "components/ui/buttons/button-icon-left/ButtonIconLeft";
import DefaultSelect from "../../../../components/ui/inputs/selects/default-select/DefaultSelect";
import LimitedCharactersInput from "components/ui/inputs/limited-characters-input/LimitedCharactersInput";
import * as actions from "../../../../store";
import {useDispatch, useSelector} from "react-redux";
import {E5_01_B_03} from "../../../texts";
import {createNote, mapDevicesToIccidList, simsToIccIdAndMsisdnList} from "../../../utils/utils";
import RichiestaInviataDialog from "../richiesta-inviata-dialog/RichiestaInviataDialog";
import ButtonWithProgress from "../../../../components/ui/buttons/button-with-progress/ButtonWithProgress";
import FormControl from "@material-ui/core/FormControl";
import {colors} from "../../../colors";
import AggiungiReferenteSegnalazione from "./aggiungi-referente-segnalazione/AggiungiReferenteSegnalazione";
import {assistanceType, getProdottoTypes} from "./SegnalazioneDialogHelper";

const useStyles = makeStyles(() => ({
    formControl: {
        width: "100%",
    }
}));

const SegnalazioneDialog = ({
                                handleDialogClose,
                                ...props
                            }) => {
    const classes = useStyles();
    const [limitedCharactersText, setLimitedCharactersText] = useState("");
    const textChanged = (text) => {
        setLimitedCharactersText(text);
    };

    const [prodotto, setProdotto] = useState("")
    const [category, setCategory] = useState("");
    const [categoryName, setCategoryName] = useState("");
    const [area, setArea] = useState("");
    const [areaName, setAreaName] = useState("");
    const [dettaglio, setDetagglio] = useState("");
    const [dettaglioName, setDetagglioName] = useState("");
    const [referente, setReferente] = useState({text: "", value: ""});
    const [openAggiungiReferenteSegnalazione, setOpenAggiungiReferenteSegnalazione] = useState(false);
    const [openRichestaInviataDialog, setOpenRichiestaInviataDialog] = useState(false);

    const segnalazione = useSelector(state => state.serviceRequestReducer.segnalazione);
    const selectedCompany = useSelector(state => state.authReducer.selectedCompany);
    const userClaims = useSelector(state => state.authReducer.userClaims);
    const ep62Flag = useSelector(state => state.authReducer.frontendConfiguration?.ep62) === "1";
    const loadingReportProblem = useSelector(state => state.serviceRequestReducer.reportProblem.loading);
    const errorReportProblem = useSelector(state => state.serviceRequestReducer.reportProblem.error);
    const activeServiceRequestForSim = useSelector(state => state.simReducer.activeServiceRequest);
    const activeServiceRequestForDevice = useSelector(state => state.deviceReducer.activeServiceRequest);
    const dispatch = useDispatch();

    // Allow button only if all fields are filled
    const disableInvia = () =>
        // TODO: remove is device rule once the device service is done
        // props.isDevice ||
        (!props.isDevice && !props.isSim && !prodotto) ||
        category.length === 0 ||
        area.length === 0 ||
        limitedCharactersText.length === 0 ||
        referente.text.length === 0 ||
        (
            (dettaglio.length === 0 && categoryName.toLowerCase() === assistanceType.TECHNICAL && (prodotto === "1" || prodotto === "2")) ||
            (limitedCharactersText.length === 0 && limitedCharactersText.length >= props.characterLimit)
        )

    const closeDialog = useCallback(() => {
        handleDialogClose();
        dispatch(actions.clearSegnalazione())
    }, [handleDialogClose, dispatch])

    const handleRichiestaInviataClose = () => {
        closeDialog()
        setOpenRichiestaInviataDialog(false);
    }

    const handleInviaClick = () => {
        setOpenRichiestaInviataDialog(true);
        if (prodotto === "1" || props.isSim) {
            handleSimInvia()
            return;
        }

        if (prodotto === "2" || props.isDevice) {
            handleDeviceInvia()
            return;
        }

        if (prodotto === "3") {
            handleInvia([])
        }
    }

    const handleDeviceInvia = () => {
        let deviceList = mapDevicesToIccidList(props.devices);
        handleInvia(deviceList);
    }

    const handleSimInvia = () => {
        let simList = simsToIccIdAndMsisdnList(props.sims);
        handleInvia(simList);
    }

    const handleInvia = (data) => {
        if (referente.added) {
            const note = createNote(limitedCharactersText, categoryName, areaName, dettaglioName, referente);
            dispatch(actions.submitReportInSegnalazione(selectedCompany.integrationId,
                selectedCompany.livelloDiAssistenzaId, E5_01_B_03,
                userClaims.uid,
                category,
                area, dettaglio, limitedCharactersText,
                '', data, note));
            return;
        }

        const note = createNote(limitedCharactersText, categoryName, areaName, dettaglioName, referente.value);
        dispatch(actions.submitReportInSegnalazione(selectedCompany.integrationId,
            selectedCompany.livelloDiAssistenzaId, E5_01_B_03,
            userClaims.uid,
            category,
            area, dettaglio, limitedCharactersText,
            referente.value, data, note));
    }

    const handleDialogCloseButton = () => {
        props.handleDialogCloseButton();
        dispatch(actions.clearSegnalazione());
    }

    const handleCategoryChange = (event) => {
        if (event.target.value !== category) {
            setCategory(event.target.value);
            dispatch(actions.getAreasInSegnalazione(selectedCompany.integrationId,
                selectedCompany.livelloDiAssistenzaId,
                E5_01_B_03, event.target.value, prodotto))
            const index = segnalazione.categoria.findIndex(item => item.value === event.target.value)
            setCategoryName(segnalazione.categoria[index].text);
            setArea("");
            setDetagglio("");
        }
    };

    const handleAreaChange = (event) => {
        setArea(event.target.value);
        const index = segnalazione.areas.findIndex(item => item.value === event.target.value)
        setAreaName(segnalazione.areas[index]?.text);
        if (event.target.value !== area && categoryName.toLowerCase() !== assistanceType.ADMINISTRATIVE) {
            dispatch(actions.getDettaglioInSegnalazione(selectedCompany.integrationId,
                selectedCompany.livelloDiAssistenzaId,
                E5_01_B_03, category, event.target.value, prodotto))
        }
        if (dettaglio !== "") {
            setDetagglio("");
        }
    };

    const handleDettaglioChange = (event) => {
        setDetagglio(event.target.value);
        const index = segnalazione.dettaglio.findIndex(item => item.value === event.target.value)
        setDetagglioName(segnalazione.dettaglio[index].text);
    };

    const handleReferenteChange = (event) => {
        if (event.target.value.toLowerCase() === "aggiungi referente per questa segnalazione") {
            setOpenAggiungiReferenteSegnalazione(true);
        } else {
            const indx = segnalazione.referentes.findIndex(ref => ref.value === event.target.value);
            if (indx !== -1) {
                setReferente(segnalazione.referentes[indx]);
            } else {
                setReferente({
                    text: "",
                    value: ""
                })
            }
        }
    };

    useEffect(() => {
        if (activeServiceRequestForSim.value && props.isSim) {
            handleDialogClose();
        }
        if (activeServiceRequestForDevice.value && props.isDevice) {
            handleDialogClose();
        }
        if (props.isSim) {
            setProdotto("1");
            dispatch(
                actions.getCategoriesInSegnalazione(
                    selectedCompany.integrationId,
                    selectedCompany.livelloDiAssistenzaId,
                    E5_01_B_03,
                    true,
                    "1"
                )
            );
        }
        if (props.isDevice) {
            setProdotto("2");
            dispatch(
                actions.getCategoriesInSegnalazione(
                    selectedCompany.integrationId,
                    selectedCompany.livelloDiAssistenzaId,
                    E5_01_B_03,
                    true,
                    "2"
                )
            );
        }
    }, [activeServiceRequestForDevice.value, props.isDevice,
        activeServiceRequestForSim.value, props.isSim,
        handleDialogClose, dispatch, selectedCompany.integrationId, selectedCompany.livelloDiAssistenzaId])

    const getTitle = () => {
        if (props.isSim && props.sims?.length >= 0) {
            if (props.sims.length === 1) {
                return `Segnalazione per la SIM ${props.sims[0].numeroDiTelefono}`
            }
            return `Segnalazione per ${props.sims.length} SIM`
        }
        if (props.isDevice && props.devices?.length >= 0) {
            if (props.devices.length === 1) {
                return `Segnalazione per la device ${props.devices[0].imei}`
            }
            return `Segnalazione per ${props.devices.length} device`
        }
        return "Segnalazione"
    }

    const handleChangeProdotto = (event) => {
        const selectedProdotto = event.target.value;
        setProdotto(selectedProdotto);
        setCategory("");
        setArea("")
        setDetagglio("");

        dispatch(
            actions.getCategoriesInSegnalazione(
                selectedCompany.integrationId,
                selectedCompany.livelloDiAssistenzaId,
                E5_01_B_03,
                true,
                selectedProdotto
            )
        );
    }

    const displayProdottoSelect = () => {
        if (props.isDevice || props.isSim)
            return null;

        return (
            <Grid container item>
                <Grid item xs={12} md={4} className="mt-12">
                    <Typography variant="subtitle2">Prodotto *</Typography>
                </Grid>

                <Grid item xs={12} md={8}>
                    <FormControl component="fieldset">
                        <RadioGroup className="d-inline"
                                    name="prodotto"
                                    value={prodotto}
                                    onChange={handleChangeProdotto}>
                            {getProdottoTypes(ep62Flag).map((p) => (
                                <FormControlLabel control={<Radio/>}
                                                  key={p.value}
                                                  value={p.value}
                                                  label={p.label}/>
                            ))}
                        </RadioGroup>
                    </FormControl>
                </Grid>
            </Grid>
        )
    }

    const dialogContent = (
        <>
            <Typography variant="h5">
                {getTitle()}
            </Typography>

            <Typography className="pb-20" variant="body2">
                Apri una segnalazione per tutti i problemi o i disservizi del tuoi asset o servizi a contratto
            </Typography>
            <Grid container spacing={3} className="mb-24">
                {displayProdottoSelect()}
                <Grid container item>
                    <Grid item xs={12} md={4} className="mt-24">
                        <Typography variant="subtitle2">Categoria *</Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <DefaultSelect
                            disabled={!prodotto}
                            menuItems={segnalazione.categoria}
                            handleOnChange={handleCategoryChange}
                            formControlStyle={classes.formControl}
                            label="Seleziona la categoria"
                            value={category}
                        />
                    </Grid>
                </Grid>
                <Grid container item>
                    <Grid item xs={12} md={4} className="mt-24">
                        <Typography variant="subtitle2"
                                    style={{color: !category ? colors.font.light : colors.font.dark}}>
                            Area *
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <DefaultSelect
                            menuItems={segnalazione.areas}
                            disabled={category === ""}
                            handleOnChange={handleAreaChange}
                            formControlStyle={classes.formControl}
                            label="Seleziona l’area"
                            value={area}
                        />
                    </Grid>
                </Grid>
                {categoryName.toLowerCase() === "assistenza tecnica" && (prodotto === "1" || prodotto === "2") ? (
                    <Grid container item>
                        <Grid item xs={12} md={4} className="mt-24">
                            <Typography variant="subtitle2"
                                        style={{color: !area ? colors.font.light : colors.font.dark}}>
                                Dettaglio *
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <DefaultSelect
                                menuItems={segnalazione.dettaglio}
                                //maybe reduntant check
                                hidden={categoryName.toLowerCase() === "assistenza amministrativa" || prodotto === "3"}
                                disabled={area === "" || prodotto === "3"}
                                handleOnChange={handleDettaglioChange}
                                formControlStyle={classes.formControl}
                                label="Seleziona il dettaglio"
                                value={dettaglio}
                            />
                        </Grid>
                    </Grid>
                ) : null}
                <Grid container item spacing={3} className="mt-24">
                    <Grid item xs={12} md={4}>
                        <Typography variant="subtitle2">Messaggio *</Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <LimitedCharactersInput label={"Descrivi qui la tua richiesta"}
                                                textChanged={textChanged}
                                                characterLimit={props.characterLimit}/>
                    </Grid>
                </Grid>
                <Grid container item>
                    <Grid item xs={12} md={4}>
                        <Typography variant="subtitle2">Referente *</Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <Typography variant="body2">
                            Indica la persona che il Servizio Clienti deve contattare per dare seguito a questa
                            segnalazione
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container item>
                    <Grid item xs={12} md={4}/>
                    <Grid item xs={12} md={8}>
                        <DefaultSelect
                            menuItems={segnalazione.referentes}
                            handleOnChange={handleReferenteChange}
                            formControlStyle={classes.formControl}
                            label="Seleziona un referente"
                            value={referente.value}
                        />
                    </Grid>
                </Grid>
            </Grid>

            {openRichestaInviataDialog && !loadingReportProblem && !errorReportProblem ? (
                <RichiestaInviataDialog
                    open={openRichestaInviataDialog}
                    handleDialogClose={handleRichiestaInviataClose}
                    handleRichiestaCloseButton={handleRichiestaInviataClose}
                />
            ) : null}

            {openAggiungiReferenteSegnalazione ? (
                <AggiungiReferenteSegnalazione
                    open={openAggiungiReferenteSegnalazione}
                    setReferente={setReferente}
                    handleDialogCloseButton={() => setOpenAggiungiReferenteSegnalazione(false)}
                    handleDialogClose={() => setOpenAggiungiReferenteSegnalazione(false)}
                    handleDialogSuccess={() => {
                        setOpenAggiungiReferenteSegnalazione(false);
                        // TODO: change behaviour of adding referente dialog
                        // setOpenSegnalazioneInviata(true);
                    }}
                />
            ) : null}
        </>
    );

    const dialogActions = (
        <Grid container
              justifyContent="space-between">
            <Button onClick={handleDialogClose}
                    color="primary"
                    variant="outlined">
                Annulla
            </Button>

            <ButtonWithProgress handleClick={handleInviaClick}
                                text="Invia"
                                variant="contained"
                                disabled={disableInvia()}
                                loading={loadingReportProblem}/>
        </Grid>
    )

    return (
        <GenericDialog
            dialogWidth="md"
            open={props.open}
            handleDialogClose={handleDialogClose}
            handleDialogCloseButton={handleDialogCloseButton}
            dialogContent={dialogContent}
            dialogActions={dialogActions}
            loading={(props.isSim || props.isDevice) ? (activeServiceRequestForSim.loading
                || activeServiceRequestForDevice.loading) : null}>
            <ButtonIconLeft
                icon={<ArrowBackIosIcon fontSize="small"/>}
                title="indietro"
                handleClick={handleDialogCloseButton}
            />
        </GenericDialog>
    );
};

SegnalazioneDialog.defaultProps = {
    isSim: false,
    isDevice: false,
    characterLimit: 1000,
    devices: [],
    sims: []
};

SegnalazioneDialog.propTypes = {
    open: PropTypes.bool,
    openAggiungi: PropTypes.func,
    sims: PropTypes.array,
    isSim: PropTypes.bool,
    characterLimit: PropTypes.number,
    handleDialogCloseButton: PropTypes.func,
    handleDialogClose: PropTypes.func
}

export default SegnalazioneDialog;
